<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <ShowSessionMinutesFile :data='data.meeting_minute_id' message="التي تم خلالها الموافقة على التعديل" />
        </b-col>
        <b-col md="4" cols="12">
            <info-card 
                label="عدد الأعضاء الذين يحق لهم حضور اجتماع الهيئة العامة/ مجلس الأمناء"
                :value="data.eligible_members_count"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
                label="عدد الأعضاء الحاضرين في الاجتماع"
                :value="data.attended_member_count"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
                label="عدد الأعضاء الموافقين على التعديل"
                :value="data.accepted_by_count"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
                label="عدد الأعضاء غير الموافقين على التعديل"
                :value="data.rejected_by_count"
            />
        </b-col>
        
        <b-col cols="12" class="mt-2">
            <h5>
            سيتم تعديل :
            </h5>
        </b-col>
        
        <b-col cols="4">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                نسخة النظام الداخلي الجديد
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:data.internal_system_doc } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col>  
        <b-col md="4" cols="12" v-if="data.modified_subject_numbers">
            <info-card
                label="ارقام المواد الجاري عليها التعديل"
                :value="data.modified_subject_numbers"
            />
        </b-col>  
        <b-col md="4" cols="12" v-if="data.name_ar" >
            <info-card
                label="اسم المنظمة باللغة العربية"
                :value="data.name_ar"
            />
        </b-col> 
        <b-col md="4" cols="12" v-if="data.name_en">
            <info-card
                label="اسم المنظمة باللغة الإنكليزية"
                :value="data.name_en"
            />
        </b-col>   
         
        <b-col md="4" cols="12" v-if="data.board_members_count">
            <info-card
                label="عدد أعضاء مجلس الإدارة / الإمناء"
                :value="data.board_members_count"
            />
        </b-col> 
        <b-col md="4" cols="12" v-if="data.term_of_office">
            <info-card
                label="مدة ولاية مجلس الإدارة / الإمناء"
                :value="data.term_of_office"
            />
        </b-col>     
        <b-col md="4" cols="12" v-if="data.objectives">
            <info-card
                label="أهداف المنظمة"
                :value="data.objectives"
            />
        </b-col> 
        <b-col md="4" cols="12" v-if="data.governorate_id">
            <info-card
                label="نطاق عملها الجغرافي"
                :value="getLabelToShow(data.governorate_id)"
            />
        </b-col>     
    </b-row>
  </template>
  
  <script>
  
    import axios from "@axios";
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import ShowSessionMinutesFile from './ShowSessionMinutesFile.vue'
  import router from "@/router";
  export default {
    data() {
        return {
            file: '',
        }
    },
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton, ShowSessionMinutesFile
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    methods :{
        getLabelToShow(value){
            return value.map(item => item.name_ar).join(', ');
        },
    },
  };
  </script>